import React from 'react';
import { LuChevronRight } from 'react-icons/lu';

/**
 * A tile that opens a section of the dashboard: icon, title, one line of description.
 * `colors` and `baseColors` are accepted for older callers but no longer needed.
 */
const MenuButton = ({ title, subtitle, icon, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group flex w-full items-center gap-3 rounded-xl border border-ui-line bg-ui-card p-4 text-left shadow-card transition-colors hover:border-brand-300 hover:bg-ui-brand-soft dark:hover:border-brand-500/40"
    >
      {icon && (
        <span className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-ui-brand-soft text-brand-600 dark:text-brand-300 [&>svg]:size-5">
          {icon}
        </span>
      )}
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold text-ui-ink">{title}</span>
        {subtitle && <span className="mt-0.5 block text-[13px] leading-snug text-ui-ink-2">{subtitle}</span>}
      </span>
      <LuChevronRight aria-hidden className="size-4 shrink-0 text-ui-ink-3 transition-transform group-hover:translate-x-0.5 group-hover:text-brand-600" />
    </button>
  );
};

export default MenuButton;
